import { lazy } from "navi";

export default lazy(() => import("./JudgeMachinePage"));
